// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"360":"79225bb6","643":"40daa814"}[chunkId] + ".chunk.js";
};